import React, { useLayoutEffect, useRef } from 'react'
import { PropTypes } from 'prop-types'
import { Paper, Box, Button, MobileStepper, Typography, makeStyles } from '@material-ui/core'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  stepper: {
    paddingBottom: 0,
    backgroundColor: 'inherit'
  }
}))

export default function StepperFooter({ numberOfSteps, activeStepIndex, handleClickBack, handleClickNext, additionalText, disableNextButton, setFooterHeight }) {
  const classes = useStyles()

  const footerHeight = useRef(0)
  useLayoutEffect(() => {
    setFooterHeight(footerHeight.current.clientHeight)
  })

  return (
    <Box ref={footerHeight} textAlign='center' component={Paper} square elevation={3} p={2} position='fixed' zIndex={1000} left='0' right='0' bottom='0'>
      {additionalText && (
        <Typography variant='body1' paragraph>
          {additionalText}
        </Typography>
      )}
      <MobileStepper
        steps={numberOfSteps}
        className={classes.stepper}
        position='static'
        variant='text'
        activeStep={activeStepIndex}
        nextButton={
          <Button disabled={disableNextButton} color='secondary' onClick={handleClickNext}>
            next
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button onClick={handleClickBack} color='secondary' disabled={activeStepIndex === 0}>
            <KeyboardArrowLeft />
            back
          </Button>
        }
      />
    </Box>
  )
}

StepperFooter.propTypes = {
  numberOfSteps: PropTypes.number.isRequired,
  activeStepIndex: PropTypes.number.isRequired,
  handleClickBack: PropTypes.func.isRequired,
  handleClickNext: PropTypes.func.isRequired,
  disableNextButton: PropTypes.bool,
  additionalText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}
